type HttpError = {
  response?: {
    status?: number;
  };
};

/** Retry bounded transient failures, but never deterministic client errors. */
const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  const status = (error as HttpError | undefined)?.response?.status;
  if (typeof status === 'number' && status >= 400 && status < 500) return false;
  return failureCount < 3;
};

export default shouldRetryQuery;
